// import whistle1 from '../sounds/whistle1.wav';
import GameState from "./game-state";
import { CheckLinkState } from './check-link-state';
import { IGame } from "../types/game";

export class FlashLineState extends GameState {

    private lineCount: number; // Store the number of lines cleared

    constructor(game: IGame) {
        super(game);
        // Match original Player_flash_lines constructor: set anim, color_flash, play sound
        // Original: anim = 0; canvas->color_flash = 255; play_sound(...) (lines 728-735)
        this.canvas.flashAnim = 0;
        // Note: color_flash is not in our ICanvas interface, but flashAnim serves similar purpose
        
        // Calculate pitch based on complexity, matching original game behavior
        // Original: 11000 + random(0-127) - (complexity << 8) Hz
        const baseFrequency = 11000; // Base frequency in Hz
        const randomVariation = Math.random() * 127; // 0-127 Hz random variation
        const complexityPenalty = this.canvas.complexity * 256; // 256 Hz per complexity level
        const targetFrequency = baseFrequency + randomVariation - complexityPenalty;
        
        // Convert frequency change to playbackRate
        let playbackRate = targetFrequency / baseFrequency;
        
        // Amplify the effect significantly to match original game's more noticeable pitch drop
        const amplificationFactor = 10.0;
        const baseRate = 1.0;
        playbackRate = baseRate - (baseRate - playbackRate) * amplificationFactor;
        
        // Clamp to minimum 0.4 and maximum 1.0
        playbackRate = Math.max(0.4, Math.min(1.0, playbackRate));
        
        // Debug logging to verify complexity is changing
        console.log(`[FlashLineState] complexity=${this.canvas.complexity}, depth=${this.canvas.depth}, playbackRate=${playbackRate.toFixed(3)}, targetFreq=${targetFrequency.toFixed(1)}Hz`);
        
        this.game.audioManager.playSound('lineFlash', playbackRate);
    }

    enter(): void {
        // Match original Player_flash_lines::init(): empty (no override in original)
        // All initialization is done in constructor
    }

    update(frameTime: number): void {
        super.update(frameTime);
        if (this.canvas.flashAnim < 16) {
            // Match original: toggle color_flash based on anim
            // Original: if((anim>>1)&1) canvas->color_flash = 200; else canvas->color_flash = 255;
            // Note: color_flash is not in our ICanvas interface, but flashAnim serves similar purpose
            this.canvas.flashAnim += 1;
        } else {
            // Match original Player_flash_lines::step() lines 747-753
            // Original: canvas->color_flash = 0; canvas->clear_tmp(); anim = 0; call(new Player_check_link(canvas)); ret();
            // Use call() to pause FlashLineState until CheckLinkState completes
            this.canvas.flashAnim = 0;
            this.canvas.clearTmp();
            
            // Use call() instead of pushState() to wait for CheckLinkState to complete
            // This allows CheckLinkState to finish (and return to CheckLineState for recursion)
            this.call(new CheckLinkState(this.game));
            
            // Mark done to remove this state after CheckLinkState completes
            this.markDone();
        }
    }
    
    toString(): string {
        return "Flash Line"
    }
    
}